import React, { useRef} from 'react';
import "../assets/css/styles.table.css"
import '../assets/additional-css/react-select.css';
import Layout from './Layout';
import { auto, right } from '@popperjs/core';
import VirtualizedSelect from 'react-virtualized-select';
import Helper from './Helper'
import {useProjectDashboardHook} from '../hook/ProjectDashboardHook'
import DynamicSelect from '../components/DynamicSelect'

const ProjectDashboard = () => {
 
  const {handleSelectedProject,refreshChart,Chart6Paging,Chart7Paging,projectList,tanggalMulai,tanggalSelesai,status,client,
    startEndProject,milestonesSelesai,milestones,tugasSelesai,tugas,anggaran,faktur,pageChart6,pageChart7,selectedOptionProject,setSelectedOptionProject
} = useProjectDashboardHook();
  
  return (
    <>
       <Layout>
                <div className='pd'><b>PROJECT DASHBOARD </b> </div>
                <div className='pd'>
                    <div className='menu' style={{display:'flex'}}>
                      <div style={{textAlign:"left", verticalAlign:"bottom", width:"100%", border:2,marginRight:10}}>
                        <DynamicSelect onChange={(option) => handleSelectedProject(option)} selectedvalue={selectedOptionProject}  clearable={false}
                            searchable={true} required={true} url={"GetProjek"} label={"{nama_project}"} value={"id"} defaultValue={setSelectedOptionProject} ></DynamicSelect>
                        {/* <VirtualizedSelect 
                            options={projectList}
                            onChange={(option) => handleSelectedProject(option.value)}
                            value={selectedOptionProject}
                            clearable={false}
                            searchable={true}
                            required
                        /> */}
                      </div>
                     
                        <div style={{textAlign:"right", justifyContent:"right", width:"200" }}>
                            <button type='button' id="btnRefresh" onClick={refreshChart} className='btn btn-primary' style={{height:35}}>Refresh</button>
                        </div>
                     </div>
                     <div className="projectsection3">
                        <div className='projectheaderBox4' style={{fontWeight:"bold",fontSize:14, color:"GrayText"}}>
                            <div style={{display:'flex', paddingBottom:40 }}>
                                <div style={{flex:1, textAlign:"left"}}>Start : {tanggalMulai}</div>
                                <div style={{flex:1,  textAlign:'center'}}>End : {tanggalSelesai}</div>
                                <div style={{flex:1,  textAlign:right}}>Status : {status}</div>
                            </div>
                            <div>
                                <div>Klien : {client}</div>
                                 
                            </div>
                       </div>
                    </div>
                    <div className="section1">
                    
                    
                    <div className='headerBox0'><b>TASK END THIS MONTH : {startEndProject.length>0 ? startEndProject[1].counts :0}</b></div> 
                    <div className='headerBox0'><b>TASK STARTS THIS MONTH :  {startEndProject.length>0 ? startEndProject[0].counts :0}</b></div> 
                  </div>
                    <div className="projectsection1">
                       <div className='projectheaderBox0' >
                            <div id="chart1"></div>
                            <div style={{textAlign:"center"}}><b>OVERALL PROGRESS</b></div>
                       </div>
                      
                       <div className='projectheaderBox0'>
                            <div id="chart3"></div>
                            <div style={{textAlign:"center"}}><b>{milestonesSelesai} DARI {milestones} COMPLETED MILESTONE</b></div>
                        </div> 
                       <div className='projectheaderBox0'>
                            <div id="chart2"></div>
                            <div style={{textAlign:"center"}}><b>{tugasSelesai} DARI {tugas} COMPLETED TASK</b></div>
                        </div> 
                </div>
                {/* <div className="section2">
                    
                       <div>SEMUA TUGAS BERDASARKAN STATUS </div>
                       <div>SEMUA TUGAS BERDASARKAN PRIORITAS </div> 
                       <div>SEMUA TUGAS BERDASARKAN KOMPLEKSITAS </div> 
                        
                </div> */}
                <div className="projectsection1">
                    
                        
                       <div  className='projectheaderBox0'>
                       <span><b>PROJECT VALUE</b></span><br></br><br></br>
                       <b><h3>IDR {Helper.formatAsCurrency(anggaran)}</h3></b>
                       </div> 
                       <div  className='projectheaderBox0'> 
                            <span><b>INVOICE</b></span><br></br><br></br>
                            <b><h3>IDR {Helper.formatAsCurrency(faktur)}</h3></b>
                        </div> 
                        <div  className='projectheaderBox0'> 
                        <span><b>REMAINING</b></span><br></br><br></br>
                        <b><h3>IDR {Helper.formatAsCurrency(anggaran - faktur)}</h3></b>
                        </div> 
                        
                </div>
               
                {/* <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>TUGAS & RISIKO | BERTANGGUNG JAWAB</div>
                           <div id="chart5"></div>
                       </div>
                </div> */}
                <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>PROGRESS(%) OF OVERALL PROJECT
                           <div style={{position:'absolute', right:15,top:20}}>
                              <button type='button'  onClick={(e) => Chart6Paging( pageChart6 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart6Paging(pageChart6 + 1)}>Next</button>
                            </div>
                           </div>
                           <div id="chart6"></div>
                       </div>
                </div>
                <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>PROJECT ACTIVITIES - SCHEDULE
                           <div style={{position:'absolute', right:15,top:20}}>
                              <button type='button'  onClick={(e) => Chart7Paging(pageChart7 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart7Paging(pageChart7 + 1)}>Next</button>
                            </div>
                           </div>
                           <div id="chart7"></div>
                       </div>
                </div>
                <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>TASK BASED ON % PROGRESS
                         
                           </div>
                           <div id="chart8"></div>
                       </div>
                </div>
                {/* <div className="projectsection1">
                       <div className='projectheaderBox3' >
                          <div className='title'>TOTAL RISIKO/ISU</div>
                          <div id="chart9"></div>
                       </div>
                       <div className='projectheaderBox3' >
                          <div className='title'>TIPE RISIKO</div>
                          <div id="chart10"></div>
                        </div> 
                       <div className='projectheaderBox3' >
                          <div className='title'>TINGKAT RISIKO</div>
                          <div id="chart11"></div>
                        </div> 
                       
                </div> */}
 
                </div>

                {/* <div className='pd_headline'><b>LAPORAN STATUS PROJEK</b><br /> <br /></div>
                <div className='pd'>
                <div className="projectsection1">
                       <div className='projectheaderBox3'></div>
                       <div className='projectheaderBox3'></div> 
                       <div className='projectheaderBox3'></div> 
                       
                </div>
                <div className="projectsection1">
                       <div className='projectheaderBox3'></div>
                       <div className='projectheaderBox3'></div> 
                       <div className='projectheaderBox3'></div> 
                       
                </div>
                </div> */}

               

         </Layout>

    </>
  );
};

export default ProjectDashboard;